import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Tags from 'bundles/apex/custom_fields/filters/tags';
import { changeCustomFieldFilters } from 'bundles/comps/index/store/actions/query';
import { delayRetrieveRecords } from 'bundles/comps/index/store/actions/search';
import { filterByTab } from './helpers';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filters } from 'bundles/apex/custom_fields/filters/types';

export default function CompsCustomFieldFilterTags() {
  const currentTab: string = useSelector((state: any) => state.ui.currentTab);
  const schemas: CustomFieldSchema[] = useSelector((state: any) => state.customFieldSchemas);
  const filters: Filters = useSelector((state: any) => state.query.customFieldFilters) || {};
  const dispatch = useDispatch();

  function changeFilter(filter: Partial<Filters>) {
    dispatch(changeCustomFieldFilters(filter));
    // TODO: No reason for this to be debounced, but something is wrong with the comp store and
    //       using a non-debounced action acted incorrectly
    dispatch(delayRetrieveRecords());
  }

  return (
    <Tags
      changeFilter={changeFilter}
      filterFunction={filterByTab(currentTab)}
      filters={filters}
      schemas={schemas}
    />
  );
}
